import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VarDirective } from './var.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [VarDirective],
  exports: [VarDirective],
})
export class VarModule { }
